var map = {
	"./AUSTRALIA.jpg": 5624,
	"./BRAZIL.jpg": 6886,
	"./GERMANY.jpg": 62429,
	"./PHONE1.jpg": 5377,
	"./PHONE2.jpg": 35030,
	"./PHONE3.jpg": 21491,
	"./PHONE4.jpg": 38656,
	"./UK.jpg": 73120,
	"./USA.jpg": 54191,
	"./dashborad-1.jpg": 33486,
	"./dashborad-2.jpg": 24249,
	"./dashborad-3.jpg": 3196,
	"./img-dropbox-bg.svg": 81566,
	"./img-gpay.png": 35225,
	"./img-paypal.png": 53563,
	"./img-phonepay.png": 85832,
	"./img-prod-1.jpg": 32643,
	"./img-prod-2.jpg": 30836,
	"./img-prod-3.jpg": 9361,
	"./img-prod-4.jpg": 12802,
	"./message/message1.svg": 10704,
	"./message/message2.svg": 72195,
	"./message/message3.svg": 34258,
	"./message/message4.svg": 68189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;